/* Amsterdam Gourmet Store - theme JS */
document.addEventListener('DOMContentLoaded', () => {
  const header = document.getElementById('siteHeader');
  const hamburger = document.getElementById('hamburger');
  const factEl = document.getElementById('cheeseFact');

  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 80);
    });
  }

  if (hamburger && header) {
    hamburger.addEventListener('click', () => {
      header.classList.toggle('menu-open');
    });
  }

  document.querySelectorAll('.mobile-menu-panel a').forEach(link => {
    link.addEventListener('click', () => {
      if (header) header.classList.remove('menu-open');
    });
  });

  const facts = [
    'Gouda has been crafted since 1184 AD.',
    'Ageing can create caramel notes and crunchy crystals.',
    'A great cheese board needs contrast: soft, aged, creamy and bold.',
    'European cheese is shaped by region, recipe, climate and patience.',
    'Cheese can turn simple hosting into a premium lifestyle moment.'
  ];

  let factIndex = 0;
  setInterval(() => {
    if (!factEl) return;
    factIndex = (factIndex + 1) % facts.length;
    factEl.style.opacity = 0;
    setTimeout(() => {
      factEl.textContent = facts[factIndex];
      factEl.style.opacity = 1;
    }, 260);
  }, 4200);
});
